import moment from "moment";
import React, { useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import { EducacionFormal } from "../../../../models/JuradosModel/jurados.model";
import DocumentosService from "../../../../api/Documentos/api-documentos";
import DocumentInput from "../../../../utils/DocumentInput";
import DateInput from "../../../../utils/DateInput";
type ModalEducacionFormalProps = {
  openModal: boolean;
  setOpenModal: Function;
  datosSelected: EducacionFormal;
  setDatosSelected: Function;
  eduacionFormalArray: EducacionFormal[];
  indexDatosSelected: number;
  setEduacionFormalArray: Function;
};
export const ModalEducacionFormal = ({
  openModal,
  setOpenModal,
  datosSelected,
  setDatosSelected,
  eduacionFormalArray,
  indexDatosSelected,
  setEduacionFormalArray,
}: ModalEducacionFormalProps) => {
  const fields = [
    { name: "nivel_educacion", value: datosSelected.nivel_educacion },
    { name: "titulo", value: datosSelected.titulo },
    {
      name: "institucion_educativa",
      value: datosSelected.institucion_educativa,
    },
    { name: "ciudad", value: datosSelected.ciudad },
    { name: "graduado", value: datosSelected.graduado },
    { name: "fecha_graduacion", value: datosSelected.fecha_graduacion },
    { name: "path_anexo", value: datosSelected.path_anexo },
  ];

  const fileInputRef = useRef<any>();
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return setDatosSelected({ ...datosSelected, path_anexo: data.data });
    }
  };

  // const [isGraduado, setIsGraduado] = useState(datosSelected.graduado);
  const handleGraduacion = ({ target }: any) => {
    if (target.value) {
      setDatosSelected({
        ...datosSelected,
        graduado: target.value,
        fecha_graduacion: "",
        path_anexo: "",
      });
      // setIsGraduado(target.value);
    } else {
      setDatosSelected({
        ...datosSelected,
        graduado: target.value,
        fecha_graduacion: "",
        path_anexo: "",
      });
      // setIsGraduado(target.value);
    }
  };
  const formRef = useRef<any>();
  const resetForm = () => {
    formRef.current.resetFields();
    setDatosSelected(initialValues);
  };
  const guardarFormulario = (values: EducacionFormal) => {
    console.log(values);

    let newArrayMod = eduacionFormalArray.map((x, idx) => {
      if (idx === indexDatosSelected) {
        return {
          ...values,
        };
      }
      return x;
    });
    setEduacionFormalArray(newArrayMod);
    setOpenModal(false);
  };
  return (
    <>
      <Modal
        title={
          <>
            Editar educación formal -{" "}
            <span
              style={{
                color: "#DD0A0A",
                fontSize: "10px",
                fontFamily: "Montserrat-Regular",
              }}
            >
              Todos los campos son obligatorios
            </span>
          </>
        }
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.8)",
        }}
        visible={openModal}
        onCancel={() => setOpenModal(false)}
        width={1600}
        footer={
          <div className="d-flex justify-content-end">
            <div className="row g-2">
              <div className="col align-self-end">
                <Button
                  className="button-gray-ghost pe-1 me-0"
                  key="back"
                  onClick={() => setOpenModal(false)}
                >
                  Cancelar
                </Button>
              </div>
              <div className="col align-self-end">
                <Button
                  className="button-azul-ghost me-1"
                  style={{ marginBottom: "20px" }}
                  onClick={resetForm}
                >
                  Limpiar campos
                </Button>
              </div>
              <div className="col align-self-end me-md-2">
                <Button
                  className="button-blanco-radius"
                  form="educacionFormalFormModal"
                  htmlType="submit"
                >
                  Guardar cambios
                </Button>
              </div>
            </div>
          </div>
        }
      >
        <Form
          ref={formRef}
          name="educacionFormalFormModal"
          size="large"
          fields={fields}
          onFinish={guardarFormulario}
          onFieldsChange={(_, fields: any) => {
            let infoupdate: any = { ...datosSelected };
            for (var i in fields) {
              infoupdate[fields[i].name] = fields[i].value;
            }
            setDatosSelected(infoupdate);
          }}
        >
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Nivel de educación
              </span>
              <Form.Item
                className="no-margin"
                name="nivel_educacion"
                rules={[{ required: true, message: "" }]}
              >
                <Select placeholder="Seleccionar">
                  <Select.Option value="Técnica">Técnica</Select.Option>
                  <Select.Option value="Tecnología">Tecnología</Select.Option>
                  <Select.Option value="Profesional">Profesional</Select.Option>
                  <Select.Option value="Especialización">Especialización</Select.Option>
                  <Select.Option value="Maestría">Maestría</Select.Option>
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Título
              </span>
              <Form.Item
                className="no-margin"
                name="titulo"
                rules={[{ required: true, message: "" }]}
              >
                <Input maxLength={80} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                Institución educativa
              </span>
              <Form.Item
                className="no-margin"
                name="institucion_educativa"
                rules={[{ required: true, message: "" }]}
              >
                <Input maxLength={100} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                Ciudad
              </span>
              <Form.Item
                className="no-margin"
                name="ciudad"
                rules={[{ required: true, message: "" }]}
              >
                <Input maxLength={80} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                ¿Graduado?
              </span>
              <Form.Item
                className="no-margin"
                name="graduado"
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group onChange={handleGraduacion}>
                  <Radio value={true}>Sí</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            {datosSelected.graduado ? (
              <>
                <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
                  <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                    Fecha de graduación
                  </span>
                  <Form.Item
                    className="no-margin"
                    name="fecha_graduacion"
                    rules={[
                      { required: true, message: "Documento obligatorio" },
                    ]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setDatosSelected({
                          ...datosSelected,
                          fecha_graduacion: fecha,
                        });
                      }}
                      dia={datosSelected?.fecha_graduacion?.split("-")[2] || ""}
                      mes={datosSelected?.fecha_graduacion?.split("-")[1] || ""}
                      anio={
                        datosSelected?.fecha_graduacion?.split("-")[0] || ""
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
                  <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                    Diploma o certificado
                  </span>
                  <Form.Item
                    className="no-margin"
                    name="path_anexo"
                    rules={[
                      { required: true, message: "Documento obligatorio" },
                    ]}
                  >
                    <DocumentInput
                      doc={datosSelected.path_anexo}
                      fileInputRef={fileInputRef}
                      ancho_btn={30}
                      on_change={(e) => {
                        guardarArchivo(e);
                        e.target.value = "";
                      }}
                      onDelete={() => {
                        setDatosSelected({
                          ...datosSelected,
                          path_anexo: "",
                        });
                      }}
                    />
                  </Form.Item>
                </div>
              </>
            ) : (
              <div className="col-12 col-md-6 col-lg-4 col-xxl-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                  Certificados de estudios
                </span>
                <Form.Item
                  className="no-margin"
                  name="path_anexo"
                  rules={[{ required: true, message: "Documento obligatorio" }]}
                >
                  <DocumentInput
                    doc={datosSelected.path_anexo}
                    fileInputRef={fileInputRef}
                    ancho_btn={30}
                    on_change={(e) => {
                      guardarArchivo(e);
                      e.target.value = "";
                    }}
                    onDelete={() => {
                      setDatosSelected({
                        ...datosSelected,
                        path_anexo: "",
                      });
                    }}
                  />
                </Form.Item>
              </div>
            )}
          </div>
        </Form>
      </Modal>
    </>
  );
};
const initialValues = {
  nivel_educacion: "",
  titulo: "",
  institucion_educativa: "",
  ciudad: "",
  graduado: true,
  fecha_graduacion: "",
  fecha_graduacion_dia: "",
  fecha_graduacion_mes: "",
  fecha_graduacion_año: "",
  path_anexo: "",
};
